export default "__VITE_ASSET__DQwBk4t___"